import React, {FormEvent, useState} from 'react'
import {PaymentElement, useElements, useStripe,} from '@stripe/react-stripe-js'
import {from} from "rxjs"
import {Button} from "antd"
import {pipe} from "fp-ts/function"
import * as OBS from "fp-ts-rxjs/Observable"
import {StripeError} from "@stripe/stripe-js/dist/stripe-js/stripe"
import {useNavigate} from "react-router-dom"
import configData from '../../config/config.json'

interface Props {
    readonly clientSecret: string
    readonly enrollmentId: string
}

export const EnrollmentPaymentFormComponent = ({clientSecret, enrollmentId}: Props) => {
    const [loading, setLoading] = useState<boolean>(false)

    const stripe = useStripe()
    const elements = useElements()
    const navigate = useNavigate()

    const handleSubmit = (event: FormEvent<HTMLFormElement>): void => {
        setLoading(true)

        event.preventDefault()

        if (!stripe || !elements) return

        pipe(
            from(elements.submit()),
            OBS.chain(result =>
                result.error
                    ? from(Promise.reject(result.error))
                    : from(Promise.resolve())),
            OBS.chain(() => from(
                    stripe!.confirmPayment({
                        elements,
                        clientSecret,
                        confirmParams: {
                            return_url: configData.BASE_FE_URL + 'enrollments/payment/confirm'
                        }
                    })
                )
            )
        ).subscribe(
            () => {
                // Your customer will be redirected to your `return_url`. For some payment
                // methods like iDEAL, your customer will be redirected to an intermediate
                // site first to authorize the payment, then redirected to the `return_url`.
            },
            (error: StripeError) => {
                setLoading(false)
                console.error(error) // TODO-BF
            },
            () => setLoading(false)
        )
    }

    const goToNewEnrollments = (): void => {
        navigate('/enrollments/new?enrollmentId=' + enrollmentId)
    }

    return (
        <form onSubmit={event => handleSubmit(event)}>
            <div className="enrollment-actions">
                <Button type="default" onClick={() => goToNewEnrollments()}>
                    Indietro
                </Button>
                <Button type="primary" disabled={!stripe || !elements || loading} htmlType="submit">
                    Conferma
                </Button>
            </div>
            <PaymentElement/>
        </form>
    )

}